/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import ErrorName from '../../error/error-name';

/**
 * Správce ovládání pro standardní webové technologie.
 * @implements {ControlManager}
 */
class WebControlManager {
  /**
   * Vytvoří instanci.
   * @param {ControlListener} listener Naslouchač událostem v ovládání.
   */
  constructor(listener) {
    this.listener = listener;
  }

  /** @inheritdoc */
  getLocalLock() {
    return new Promise(() => {
      const error = new Error(
        'Getting the local control lock is not supported.'
      );
      error.name = ErrorName.NotSupportedError;
      throw error;
    });
  }

  /** @inheritdoc */
  getRemoteLock() {
    return new Promise(() => {
      const error = new Error(
        'Getting the remote control lock is not supported.'
      );
      error.name = ErrorName.NotSupportedError;
      throw error;
    });
  }

  /** @inheritdoc */
  off(type, callback) {
    this.listener.off(type, callback);
  }

  /** @inheritdoc */
  on(type, callback) {
    this.listener.on(type, callback);
  }

  /** @inheritdoc */
  setLocalLock(lock) {
    return new Promise(() => {
      const error = new Error(
        'Setting the local control lock is not supported.'
      );
      error.name = ErrorName.NotSupportedError;
      throw error;
    });
  }

  /** @inheritdoc */
  setRemoteLock(lock) {
    return new Promise(() => {
      const error = new Error(
        'Setting the remote control lock is not supported.'
      );
      error.name = ErrorName.NotSupportedError;
      throw error;
    });
  }
}

export default WebControlManager;
